var _path, _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroupBottomLineImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1537,
    height: 690,
    viewBox: "0 0 1537 690",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M363 282.087C421.869 461.643 527.286 536.841 879.131 409.464C909.25 409.464 1677.29 84.1157 1510.26 449.365",
    stroke: "url(#paint0_linear_395_18)",
    strokeOpacity: 0.13,
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_395_18",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -310,
    y: 0,
    width: 619,
    height: 690
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 38.1963,
    width: 571,
    height: 394,
    transform: "rotate(61.789 38.1963 0)",
    fill: "#2E2E2E"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_395_18)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-304.904 266.471L122.779 278.61L-103.647 641.641L-304.904 266.471Z",
    stroke: "white",
    strokeOpacity: 0.24,
    strokeWidth: 56.8844
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_395_18",
    x1: 1534.4,
    y1: 354.42,
    x2: 362.612,
    y2: 340.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#211E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#211E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8176AF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupBottomLineImg);
export default __webpack_public_path__ + "static/media/groupBottomLineImg.215eb570f2c6195a45ab6a92b759316e.svg";
export { ForwardRef as ReactComponent };